import React, { useState } from 'react';
import Drawer from '@mui/material/Drawer';
import Grid from '@mui/material/Grid';
import { useTheme, styled } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useSelector, useDispatch } from 'react-redux';
import MonacoThemeCodeEditor from './MonacoThemeCodeEditor';
import ThemeTools from './ThemeTools/ThemeTools';
// import { toggleThemeConfig } from '../state/themeSlice';
import { toggleThemeConfig } from '../slices/commonSlice/themeSlice';
import { RootState } from '../app/store';

const drawerWidth = 333;

const StyledDrawer = styled(Drawer)({
  width: drawerWidth,
  height: '100vh',
  maxWidth: '90vw',
  zIndex: 1,
});

const StyledDrawerPaper = styled('div')(({ theme }) => ({
  width: drawerWidth,
  overflowY: 'visible',
  maxWidth: '90vw',
  fontFamily : "source-sans-pro"
}));

const StyledGridContainer = styled(Grid)({
  height: '100vh',
});

const StyledGridItem = styled(Grid)(({ theme }) => ({
  minHeight: '30vh',
  height: '100%',
}));

const ThemeConfigDrawer = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const savedThemes = useSelector((state: RootState) => state.theme.savedThemes);
  const defaultThemeId = Object.keys(savedThemes)[0];
  const open = useSelector((state: RootState) => state.theme.themeConfigOpen);
  const permanent = useMediaQuery(theme.breakpoints.up('sm'));

  return (
    <StyledDrawer
      variant={permanent ? 'permanent' : 'temporary'}
      anchor="right"
      open={open}
      onClose={() => dispatch(toggleThemeConfig())}
    >
      <StyledDrawerPaper>
        <StyledGridContainer container direction="column" wrap="nowrap">
          <StyledGridItem item>
            <MonacoThemeCodeEditor key={defaultThemeId} />
          </StyledGridItem>
          <StyledGridItem item>
            <ThemeTools /> {/* this is text */}
          </StyledGridItem>
        </StyledGridContainer>
      </StyledDrawerPaper>
    </StyledDrawer>
  );
};

export default ThemeConfigDrawer;
